import { appEntry } from '@/mocks/homeData';

export default function App() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 max-w-[960px] mx-auto">
          <div className="flex-shrink-0 w-full max-w-[320px] lg:max-w-[360px]">
            <div className="relative rounded-2xl overflow-hidden aspect-[9/16] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20smartphone%20mockup%20displaying%20entertainment%20content%20app%20interface%2C%20warm%20dark%20theme%20with%20golden%20accents%2C%20clean%20UI%20design%2C%20content%20cards%20layout%2C%20minimal%20device%20frame%2C%20professional%20product%20photography%20on%20neutral%20background&width=720&height=1280&seq=app-mockup-001&orientation=portrait"
                alt="51吃瓜网站移动端浏览效果展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              {appEntry.title}
            </h2>
            <div className="mt-4 w-16 h-1 bg-primary-500 mx-auto lg:mx-0 rounded-full"></div>
            <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">
              {appEntry.description}
            </p>
            <div className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer hover:bg-primary-600 transition-colors duration-200">
              <i className="ri-smartphone-line"></i>
              <span className="whitespace-nowrap">在浏览器中打开</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}